import React from 'react';
import { Box, TextField, IconButton, Stack, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

const KeyValueEditor = ({ data, setData }) => {
  const handleAdd = () => {
    setData([...data, { id: Date.now(), key: '', value: '' }]);
  };

  const handleRemove = (id) => {
    setData(data.filter(item => item.id !== id));
  };

  const handleChange = (id, field, value) => {
    setData(data.map(item => (item.id === id ? { ...item, [field]: value } : item)));
  };

  return (
    <Box sx={{ p: 2, height: '100%', overflowY: 'auto' }}>
      <Stack spacing={1}>
        {data.map((item, index) => (
          <Stack direction="row" spacing={1} key={item.id} alignItems="center">
            <TextField
              size="small"
              label="Key"
              value={item.key}
              onChange={(e) => handleChange(item.id, 'key', e.target.value)}
              sx={{ flex: 1 }}
            />
            <TextField
              size="small"
              label="Value"
              value={item.value}
              onChange={(e) => handleChange(item.id, 'value', e.target.value)}
              sx={{ flex: 1 }}
            />
            <IconButton onClick={() => handleRemove(item.id)} size="small">
              <RemoveIcon />
            </IconButton>
          </Stack>
        ))}
        <Button
          startIcon={<AddIcon />}
          onClick={handleAdd}
          sx={{ justifyContent: 'flex-start', mt: 1 }}
        >
          Add
        </Button>
      </Stack>
    </Box>
  );
};

export default KeyValueEditor;
